let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1BVEq")).then(() => parcelRequire('2AtWd'));